<template>
  <div class="page-layout-masonry">
    <div class="container">
      <p class="title">
        Masonry + Instagram Layout.
      </p>
      <p class="subtitle" style="margin-bottom:30px;">
        Masonry + Instagram layout.<br />
      </p>
    </div>

    <masonry-instagram></masonry-instagram>

    <section-comment style="margin-top:50px;"></section-comment>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import auth from '@/apis/Auth'
import MasonryInstagram from '@/components/MasonryInstagram'
export default {
  name: 'layoutmasonryinstagram',
  components: {
    MasonryInstagram
  },
  data () {
    return {
      images: [],
      error: undefined
    }
  },
  computed: mapGetters([
    'evenOrOdd',
    'isAuthenticated'
  ]),
  methods: {
    test () {
    },
    refresh: function () {
      auth.gallery()
      .then(data => {
        console.log('get gallery')
        console.log(data)
        this.images = data
      })
      .catch(error => {
        console.log('invalid get gallery', error)
        this.images = []
        this.error = error.error
      })
    },
    ...mapActions([
      'authenticated',
      'unauthenticated'
    ])
  },
  beforeCreate () {
  },
  created () {
    console.log('created LayoutMasonry.vue')
  },
  mounted () {
    console.log('mounted LayoutMasonry.vue')
    this.$scrollTo(0)
    this.refresh()
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-layout-masonry {
  padding-top: 60px;
}

.masonry-container {
  margin: 0 auto;
}

.masonry-item {
  margin: 0 auto 0 auto;
  padding: 10px;
  width: 100%;

  @media screen and (min-width: $tablet) {
    width: 50%;
  }

  @media screen and (min-width: $desktop) {
    width: 33.33%;
  }
}
</style>



// WEBPACK FOOTER //
// LayoutMasonryInstagram.vue?3f2f7870